// @ts-nocheck - untyped
import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import './ServicesMonitor.scss';

function getStatusStyle(status) {
  const s = (status || '').toUpperCase();
  if (s === 'UP') return { type: 'up', label: 'Operational', Icon: CheckCircleOutlineIcon };
  if (s === 'DOWN' || s === 'OUT_OF_SERVICE')
    return { type: 'down', label: 'Outage', Icon: ErrorOutlineIcon };
  return { type: 'unknown', label: 'Unknown', Icon: HelpOutlineIcon };
}

export default function HealthPanel({ data, loading, error, onRetry, onRefresh }) {
  const status = data?.status;
  const mainStatus = getStatusStyle(status);
  const MainIcon = mainStatus.Icon;

  if (loading) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <Typography color="text.secondary">Checking health…</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Paper className="sm-empty-state" elevation={0}>
        <ErrorOutlineIcon sx={{ fontSize: 48, color: 'error.main', mb: 1 }} />
        <Typography variant="body1" gutterBottom>
          {error}
        </Typography>
        {onRetry && (
          <Tooltip title="Retry">
            <IconButton onClick={onRetry} color="primary" sx={{ mt: 1 }}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        )}
      </Paper>
    );
  }

  if (!data) {
    return (
      <Paper className="sm-empty-state" elevation={0}>
        <Typography variant="body1">No health data available.</Typography>
      </Paper>
    );
  }

  const bannerClass =
    mainStatus.type === 'up'
      ? 'sm-status-banner-up'
      : mainStatus.type === 'down'
        ? 'sm-status-banner-down'
        : 'sm-status-banner-unknown';
  const statusTextClass =
    mainStatus.type === 'up'
      ? 'sm-status-up'
      : mainStatus.type === 'down'
        ? 'sm-status-down'
        : 'sm-status-unknown';

  return (
    <Box>
      <Paper className={`sm-status-banner ${bannerClass}`} elevation={0}>
        <Box className={`sm-status-text ${statusTextClass}`}>
          <MainIcon sx={{ fontSize: 28 }} />
          <span>
            {mainStatus.type === 'up'
              ? 'All systems operational'
              : mainStatus.type === 'down'
                ? 'System outage'
                : 'Status unknown'}
          </span>
          <Chip
            label={status || 'UNKNOWN'}
            size="small"
            className={
              mainStatus.type === 'up'
                ? 'sm-chip-up'
                : mainStatus.type === 'down'
                  ? 'sm-chip-down'
                  : 'sm-chip-unknown'
            }
          />
        </Box>
        {onRefresh && (
          <Tooltip title="Refresh health">
            <IconButton onClick={onRefresh} size="small" sx={{ color: 'var(--color-primary)' }}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        )}
      </Paper>
    </Box>
  );
}
